
import React from 'react';
import SidebarNav from './sidebar/SidebarNav';

const Sidebar = () => {
  return (
    <div className="w-full max-w-[280px] bg-white border-r border-gray-200 h-[calc(100vh-64px)] overflow-y-auto p-4">
      <SidebarNav />
    </div>
  );
};

export default Sidebar;
